import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-group-duration',
  templateUrl: './group-duration.page.html',
  styleUrls: ['./group-duration.page.scss'],
})
export class GroupDurationPage implements OnInit {

  constructor(
    public popoverController: PopoverController,
  ) { }

  ngOnInit() {
  }
  close(){
    this.popoverController.dismiss();
  }

}
